// Shared constants for the Operations Time Tracker.

export const WORK_TYPES = [
  'General Farm Work',
  'Livestock / Stock Work',
  'Machinery Operation',
  'Vehicle / Quad / Side-by-Side Work',
  'Cropping / Broadacre',
  'Horticulture / Orchard / Vineyard',
  'Irrigation / Water Management',
  'Chemical / Spray Work',
  'Maintenance / Repairs',
  'Fencing / Infrastructure',
  'Harvest / Packing',
  'Transport / Logistics',
  'Contractor Work',
  'Construction / Earthworks',
  'Pest / Weed / Biosecurity',
  'Safety / Compliance / Training',
  'Administration / Management',
  'Emergency / Incident Response',
  'Other',
];

export const TIME_ENTRY_STATUS = {
  active: { label: 'Active', color: '#067647' },
  on_break: { label: 'On Break', color: 'orange' },
  completed: { label: 'Completed', color: 'default' },
};

// Format a number of seconds as H:MM:SS.
export const formatDuration = (totalSeconds) => {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${hours}:${pad(minutes)}:${pad(seconds)}`;
};
